export const languagesPath = '/languages';
